export enum QueryKeys {
  GET_ALL_MAPS = 'getAllMaps',
  GET_MAP_BY_ID = 'getMapById',
  GET_MAP_LAYERS = 'getMapLayers',
  GET_LAYER_BOUNDS = 'getLayerBounds',
  GET_LAYER_GROUPS = 'getLayerGroups',
  FETCH_FEATURES_KEY_VALUE_MAPPING = 'fetchFeaturesKeyAndValueMapping',
  GET_FEATURE_TABLE = 'getFeatureTable',
  GET_FEATURE_LAYERS = 'getFeatureLayers',
  SYMBOLOGY_FIELDS = 'symbologyFields',
  SYMBOLOGY_DISTINCT_VALUES = 'symbologyDistinctValues',
  SYMBOLOGY_VALUE_SAMPLE = 'symbologyValueSample',
  GET_MAP_SKETCHES = 'getMapSketches',
  GET_MAP_SKETCH = 'getMapSketch',
  GET_MAP_ICONS = 'getMapIcons',
  FETCH_ICON_URL = 'fetchIconUrl',
  GET_RECENT_ICONS = 'getRecentIcons',
  GET_ALL_USERS = 'getAllUsers',
  GET_USER = 'getUser',
  GET_USERS_LIST = 'getUsersList',
  GET_USER_DETAILS = 'getUserDetails',
  GET_ROLES_AVAILABILITY = 'getRolesAvailability',
  GET_ORG_GROUPS = 'getOrgGroups',
  GET_CLIENT_GROUPS = 'getClientGroups',
  GET_CLIENT_DETAILS = 'getClientDetails',
  GET_CLIENTS_FOR_SELECTION = 'getClientsForSelection',
  GET_SUBSCRIPTION_TYPES = 'getSubscriptionTypes',
  GET_ADD_ONS = 'getAddOns',
  GET_PAYMENT_GROUPS = 'getPaymentGroups',
  GET_ALL_GROUPS = 'getAllGroups',
  GET_GROUP_MANAGER_GROUPS = 'getGroupManagerGroups',
  GET_GROUP_MANAGER_META_GROUPS = 'getGroupManagerMetaGroups',
  GET_GROUP_MANAGER_GROUP_DETAILS = 'getGroupManagerGroupDetails',
  GET_GROUP_MANAGER_META_USERS = 'getGroupManagerMetaUsers',
  GET_GROUP_MANAGER_META_ICONS = 'getGroupManagerMetaIcons',
  GET_GROUP_MANAGER_META_MAPS = 'getGroupManagerMetaMaps',
  GET_GROUP_MANAGER_META_FILES = 'getGroupManagerMetaFiles',
  GET_PERMISSIONS = 'getPermissions',
  GET_ALL_WORKORDERS = 'getAllWorkorders',
  GET_ALL_CONTACTS = 'getAllContacts',
  GET_CONTACT_GROUPS = 'getContactGroups',
  GET_CONTACT_GROUP_OPTIONS = 'getContactGroupOptions',
  FETCH_LAYERS_FROM_GEOSERVER = 'fetchLayersFromGeoServer',
  FETCH_ASSET_LIST_FROM_GEOSERVER = 'fetchAssetListFromGeoServer',
  GET_ALL_ASSET_TYPE_AND_ASSET_ID = 'getAllAssetTypeAndAssetId',
  GET_FOLDERS_FOR_SELECTION = 'getFoldersForSelection',
  INITIATE_BULK_DOWNLOAD = 'initiateBulkDownload',
  POLL_BULK_DOWNLOAD_STATUS = 'pollBulkDownloadStatus',
  GET_FILE_VIEW_LINK = 'getFileViewLink',

  //Auth
  AUTH_VERIFY_RESET = 'authVerifyReset',

  //Home
  GET_DASHBOARD_SERVICES = 'getDashboardServices',
  GET_DASHBOARD_SETTINGS = 'getDashboardSettings',

  //My Profile
  GET_PROFILE = 'getProfile',

  //Asset Manager
  GET_ASSET_MANAGER_STATUS = 'getAssetManagerStatus',
  GET_ASSET_MANAGER_META_LAYERS = 'getAssetManagerMetaLayers',
  GET_ASSET_MANAGER_LAYER_FIELDS = 'getAssetManagerLayerFields',
  GET_ASSET_LIST_CONFIG = 'getAssetListConfig',
  GET_ASSET_LIST_PAGE = 'getAssetListPage',
  GET_ASSET_DETAILS = 'getAssetDetails',

  //Asset Work Orders
  GET_ASSET_WORK_ORDERS = 'getAssetWorkOrders',
  GET_ASSET_WORK_ORDER = 'getAssetWorkOrder',
  GET_ASSET_WORK_ORDER_SETTINGS = 'getAssetWorkOrderSettings',
  GET_ASSET_LAYER_FIELD_VALUES = 'getAssetLayerFieldValues',
  GET_ASSET_STATISTICS = 'getAssetStatistics',
}
